/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPnnControl.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/pnn-control";

export class AutogenModelPnnControl<RowType extends ModelRow> extends Endpoint<RowType, RowPnnControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPnnControl extends ModelRow<RowPnnControlFields> {
	constructor(values?: Partial<RowPnnControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPnnControlFields {
	all_revenue_codes: string;
	brk_qual_status: string;
	comment1: string;
	company_id: string;
	default_city: string;
	default_city_id: number;
	default_city_state: string;
	default_radius: number;
	default_state: string;
	default_zip: string;
	error_email: string;
	fax_image: string;
	generic_comment: string;
	id: number;
	image_file: string;
	include_nonbrokered_loads: string;
	load_days_after: number;
	load_days_prior: number;
	load_schedule_id: string;
	order_contact: string;
	reply_detail: string;
	reply_email: string;
	reply_name: string;
	reply_via: string;
	trac_schedule_id: string;
	tractor_days_after: number;
	tractor_days_prior: number;
	unsubscribe_contact: string;
	unsubscribe_contact_detail: string;
	unsubscribe_contact_method: string;
}

